'use strict';

var _getIterator2 = require('babel-runtime/core-js/get-iterator');

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _map = require('babel-runtime/core-js/map');

var _map2 = _interopRequireDefault(_map);

var _set = require('babel-runtime/core-js/set');

var _set2 = _interopRequireDefault(_set);

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; (0, _defineProperty2.default)(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _utils = require('../utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObliviousSet = function () {
  function ObliviousSet() {
    var ttl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000 * 60;

    _classCallCheck(this, ObliviousSet);

    this.ttl = ttl;
    this.set = new _set2.default();
    this.timeMap = new _map2.default();
  }

  _createClass(ObliviousSet, [{
    key: 'has',
    value: function has(value) {
      return this.set.has(value);
    }
  }, {
    key: 'add',
    value: function add(value) {
      this.timeMap.set(value, (0, _utils.now)());
      this.set.add(value);
      this._removeTooOldValues();
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.set.clear();
      this.timeMap.clear();
    }
  }, {
    key: '_removeTooOldValues',
    value: function _removeTooOldValues() {
      var olderThen = (0, _utils.now)() - this.ttl;
      var iterator = (0, _getIterator3.default)(this.set);

      while (true) {
        var value = iterator.next().value;
        if (!value) return; // no more elements
        var time = this.timeMap.get(value);
        if (time < olderThen) {
          this.timeMap.delete(value);
          this.set.delete(value);
        } else {
          // We reached a value that is not old enough
          return;
        }
      }
    }
  }]);

  return ObliviousSet;
}();

exports.default = ObliviousSet;